module.exports = __webpack_public_path__ + "img/2-4.79fc0c6b.jpg";